import { render, staticRenderFns } from "./Iconify.vue?vue&type=template&id=4daee0a8&scoped=true&"
import script from "./Iconify.vue?vue&type=script&lang=js&"
export * from "./Iconify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daee0a8",
  null
  
)

export default component.exports